import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { ConfirmDialogService } from '../../confirm-dialog/confirm-dialog.service';
import { NotificationService } from '../../notification/notification.service';
import { WorktimeService } from '../api';
import { WorktimeBase, wtAvatarColor, wtInitial } from './worktime-shared';

// ============================================================================
// Munkaidő — a bejelentkezett user saját nézete.
// Design: erp-design/screens/08-munkaido.html (wtIsEmployee ág),
// logika: 23-logic.js worktimeVals() — közös rész a worktime-shared.ts-ben.
// ============================================================================

@Component({
  selector: 'app-munkaido',
  templateUrl: './munkaido.component.html',
  styleUrl: './munkaido.component.scss'
})
export class MunkaidoComponent extends WorktimeBase implements OnInit {

  constructor(
    worktime: WorktimeService,
    auth: AuthService,
    notification: NotificationService,
    confirmDialog: ConfirmDialogService,
  ) {
    super(worktime, auth, notification, confirmDialog);
  }

  ngOnInit(): void {
    // Optimista előjelzés a bejelentkezett user adatából (a KPI-rács így nem
    // villan) — a mérvadó érték a summary employmentType mezője.
    const cached = (this.auth.user as { employment_type?: string } | null)?.employment_type;
    if (cached === 'external' || cached === 'employee') {
      this.employmentType = cached;
    }
    this.reload();
  }

  /** Saját nézet: a szerver a tokenből tudja a usert — nem küldünk userId-t. */
  protected override targetUserId(): number | undefined {
    return undefined;
  }

  get ownName(): string {
    const u = this.auth.user;
    return u ? (u.full_name || u.username) : '';
  }

  get ownInitial(): string {
    return wtInitial(this.ownName);
  }

  get ownColor(): string {
    return wtAvatarColor(this.ownName);
  }
}
